import "core-js/es/math/trunc";
import "custom-event-polyfill";
